module.exports = __webpack_public_path__ + "media/enrollnow/enrollnow_link_image-b7bdc6a9.png";